// Validation rules: https://vee-validate.logaretm.com/v4/guide/global-validators/#available-rules

import { defineRule, configure } from 'vee-validate';
import { all } from '@vee-validate/rules';
import { localize, setLocale } from '@vee-validate/i18n';
import { required, min, max, email } from '@vee-validate/rules';

// You can import the needed locale from the @vee-validate/i18n/dist/locale/{localeCode}.json and they can be passed directly to the localize function.
import en from '@vee-validate/i18n/dist/locale/en.json';
import es from '@vee-validate/i18n/dist/locale/es.json';

configure({
    generateMessage: localize({
        en,
        es
    })
});

// Set language by default
setLocale(localStorage.getItem('locale') ?? 'en');

// Register all VeeValidate rules
Object.entries(all).forEach(([name, rule]) => {
    defineRule(name, rule);
});

// Register the rules
defineRule('required', required);
defineRule('min', min);
defineRule('max', max);
defineRule('email', email);
defineRule('minValue', (value, [min]) => {
    if (!value || !min) {
        return true;
    }
    const numValue = Number(value);
    return numValue >= min;
});

defineRule('minLength', (value, [minLength]) => {
    if (!value || !minLength) {
        return true;
    }
    const stringValue = String(value).trim();
    return stringValue.length >= Number(minLength);
});

defineRule('decimal', (value) => {
    // Field is empty, should pass
    if (!value || !value.length) {
        return true;
    }

    // Check if decimal
    if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        return 'This field must be a valid decimal number.';
    }

    return true;
});

defineRule('timeRange', (value, [iniField, endField], ctx) => {
    const ini = ctx.form[iniField];
    const end = ctx.form[endField];
    if (!ini || !end) return true;

    const [iniH, iniM] = ini.split(':').map(Number);
    const [endH, endM] = end.split(':').map(Number);
    const iniMinutes = iniH * 60 + iniM;
    const endMinutes = endH * 60 + endM;

    if (endMinutes < iniMinutes) {
        return 'timeRange';
    }
    return true;
});
